(function (module) {
  'use strict';
  module
    .controller('gdsSettingsController', ['$scope', 'progressBar', 'agencySelectService',
      'gdsSettings', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state',
      '$stateParams', 'authService',
      function ($scope, progressBar, agencySelectService, gdsSettings, ngDialog,
        uiGridConstants, commonDialog, commonDialogMessage, $state, $stateParams, authService) {
        const progress = progressBar.getProgressBar();
        const id = $stateParams.id;

        $scope.gdsArr = [{
          id: 0,
          name: 'Sabre'
        }, {
          id: 1,
          name: 'Apollo'
        }, {
          id: 2,
          name: 'Worldspan'
        }, {
          id: 3,
          name: 'Galileo'
        }, {
          id: 4,
          name: 'Axess'
        }, {
          id: 5,
          name: 'Amadeus'
        }];
        $scope.confirmPassword = null;
        $scope.gdsSetting = {
          Id: 0,
          GDS: null,
          IPCC: null,
          OrganizationId: 0,
          Password: null,
          QueueId: null,
          QueueModifier: null,
          Username: null,
          CIDBNumber: null,
          OriginApplication: null,
          PseudoCityCode: null,
          TargetBranch: null,
          Category: null
        };

        if (!!id) {
          console.log("Id: ", id);
          getGdsSettingById(id);
          $scope.isEdit = true;
        };

        function getGdsSettingById(id) {
          progress.start();
          gdsSettings.getGdsSettingById(id).then(function (responseData) {
            console.log(responseData);
            $scope.isEdit = true;
            const gdsSetting = responseData.data;
            $scope.gdsSetting = gdsSetting;
            console.log($scope.gdsSetting, "gds setting");
          }, function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Get Gds Setting Error';
                },],
              });
            }
          })
            .finally(function () {
              progress.complete();
            });
        };
        // Begin ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        // ui-grid options
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          visible: true,
          enableColumnResizing: true,
          columnDefs: [{
            name: 'GDS',
            displayName: 'GDS',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
            cellTemplate: '<span ng-if="(row.entity.GDS==0)" style="padding: 0px 2px 2px 5px;">Sabre</span>' +
              '<span ng-if="(row.entity.GDS==1)" style="padding: 0px 2px 2px 5px;">Apollo</span>' +
              '<span ng-if="(row.entity.GDS==2)" style="padding: 0px 2px 2px 5px;">Worldspan</span>' +
              '<span ng-if="(row.entity.GDS==3)" style="padding: 0px 2px 2px 5px;">Galileo</span>' +
              '<span ng-if="(row.entity.GDS==4)" style="padding: 0px 2px 2px 5px;">Axess</span>' +
              '<span ng-if="(row.entity.GDS==5)" style="padding: 0px 2px 2px 5px;">Amadeus</span>',
          }, {
            name: 'IPCC',
            displayName: 'IPCC',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Username',
            displayName: 'Username',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'QueueId',
            displayName: 'Queue Id',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'QueueModifier',
            displayName: 'Queue Modifier',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'CIDBNumber',
            displayName: 'CIDB Number',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'OriginApplication',
            displayName: 'Origin Application',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'PseudoCityCode',
            displayName: 'Pseudo City Code',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'TargetBranch',
            displayName: 'Target Branch',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Category',
            displayName: 'Category',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          },],
          onRegisterApi: function (gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              setGridData();
            });
            // Show organization details on grid row selection.
            gridApi.selection.on.rowSelectionChanged($scope, function (row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };

        $scope.edit = function () {
          $state.go('app.editGdsSetting', {
            id: $scope.rowSelectingId,
          });
        };

        $scope.saveGdsSetting = function () {
          const agency = agencySelectService.getSelectedAgency();
          const orgId = agency.id;
          $scope.gdsSetting.OrganizationId = orgId;
          if (!!$scope.gdsSetting.OrganizationId) {
            const passwordInvalid = !$scope.gdsSetting.Password ? true : false
            const gdsInvalid = $scope.gdsSetting.GDS === null ? true : false;
            const userNameInvalid = !$scope.gdsSetting.Username ? true : false;
            const queueIdInvalid = !$scope.gdsSetting.QueueId ? true : false;
            const confirmPasswordInvalid = ($scope.gdsSetting.Password !== $scope.confirmPassword) ? true : false;
            if (gdsInvalid || userNameInvalid || passwordInvalid || queueIdInvalid || confirmPasswordInvalid) {
              const dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '';
                  $scope.errTitle = 'Add GDS setting error';
                  if (gdsInvalid) {
                    $scope.errMsg += '<p>GDS must be entered.</p>';
                  }
                  if (userNameInvalid) {
                    $scope.errMsg += '<p>Username must be entered.</p>';
                  }
                  if (passwordInvalid) {
                    $scope.errMsg += '<p>Password must be entered.</p>';
                  }
                  if (queueIdInvalid) {
                    $scope.errMsg += '<p>QueueId must be entered.</p>';
                  }
                  if (confirmPasswordInvalid) {
                    $scope.errMsg += '<p>Password and Confirm Password do not match.</p>';
                  }
                },],
              });
              dialog.closePromise.then(function (data) { });
            } else {
              progress.start();
              gdsSettings.addGdsSetting($scope.gdsSetting, orgId).then(function () {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Add GDS setting Success';
                    $scope.successMsg = 'The GDS setting has been added succesfully.';
                  },],
                });
                dialogPost.closePromise.then(function (data) {
                  $state.go('app.gdsSettings');
                });
              }, function (err) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                    $scope.errTitle = 'GDS Setting Error';
                  },],
                });
              }).finally(function () {
                progress.complete();
              });
            }
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>Please select agency</p>`;
                $scope.errTitle = 'GDS Setting Error';
              },],
            });
          }
        };
        $scope.updateGdsSetting = function () {
          if (!!$scope.gdsSetting.OrganizationId) {
            const passwordInvalid = !$scope.gdsSetting.Password ? true : false;            
            //need to add like this because for sabre value is 0 and if we add !$scope.gdsSetting.GDS it fails for sabre
            const gdsInvalid = ($scope.gdsSetting.GDS === null) ? true : false;
            const userNameInvalid = !$scope.gdsSetting.Username ? true : false;
            const queueIdInvalid = !$scope.gdsSetting.QueueId ? true : false;
            const confirmPasswordInvalid = ($scope.gdsSetting.Password !== $scope.confirmPassword) ? true : false;
            if (gdsInvalid || userNameInvalid || passwordInvalid || queueIdInvalid || confirmPasswordInvalid) {
              const dialog = ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = '';
                  $scope.errTitle = 'Edit GDS setting error';
                  if (gdsInvalid) {
                    $scope.errMsg += '<p>GDS must be entered.</p>';
                  }
                  if (userNameInvalid) {
                    $scope.errMsg += '<p>Username must be entered.</p>';
                  }
                  if (passwordInvalid) {
                    $scope.errMsg += '<p>Password must be entered.</p>';
                  }
                  if (queueIdInvalid) {
                    $scope.errMsg += '<p>QueueId must be entered.</p>';
                  }
                  if (confirmPasswordInvalid) {
                    $scope.errMsg += '<p>Password and Confirm Password do not match.</p>';
                  }
                },],
              });
              dialog.closePromise.then(function (data) { });
            } else {
              progress.start();
              gdsSettings.updateGdsSetting($scope.gdsSetting.Id, $scope.gdsSetting).then(function (response) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Edit GDS setting Success';
                    $scope.successMsg = 'The GDS setting has been updated succesfully.';
                  },],
                });
                dialogPost.closePromise.then(function (data) {
                  $state.go('app.gdsSettings');
                });
              }, function (err) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                    $scope.errTitle = 'Update GDS setting Error';
                  },],
                });
              })
                .finally(function () {
                  progress.complete();
                });
            }
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>Please select an agency</p>`;
                $scope.errTitle = 'GDS Setting Error';
              },],
            });
          }
        };

        $scope.deleteGdsSetting = function () {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete GDS setting?';
              $scope.strMsg = 'Do you really want to delete this GDS setting?';
            },],
          });
          confirm.closePromise.then(function (data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              gdsSettings.deleteGdsSetting($scope.rowSelectingId).then(function (del) {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Delete GDS Setting Success';
                    $scope.successMsg = 'Gds setting deleted successfully';
                  },],
                });
                dialogPost.closePromise.then(function (data) {
                  setGridData();
                });
              }, function (err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Delete GDS Setting Error';
                    },],
                  });
                }
              })
                .finally(function () {
                  progress.complete();
                });
            }
          });
        };

        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();

          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),

          };
        }

        function setGridData() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid) {
            progress.start();
            const agency = agencySelectService.getSelectedAgency();
            gdsSettings.getGdsSettingsByAgencyId(agency.id).then(function (gdsSettings) {
              const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
              $scope.gridOptions.data = gdsSettings.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
              $scope.gridOptions.totalItems = gdsSettings.data.length;
            }, function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                    $scope.errTitle = 'GDS Setting Error';
                  },],
                });
              }
            }).finally(function () {
              progress.complete();
            });
          } 
        };

        $scope.view = function (rowEntity) {
          const selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
          if (!!selectedRow) {
            $scope.gdsSetting = selectedRow;
            $scope.gdsName = $scope.gdsArr[selectedRow.GDS].name;
            const view = ngDialog.open({
              template: 'templates/partials/viewGdsSetting.html',
              className: 'ngdialog-theme-plain',
              scope: $scope,
            });
            view.closePromise.then(function (data) {
              $scope.viewData = {};
            });
          }
        };
        setGridData();
        // Watch clientSelectService for changes to getFilteredOrganization() output
        // expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return agencySelectService.getSelectedAgency();
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.gridOptions.data = [];
            $scope.gridOptions.totalItems = 0;
            setGridData();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/gdsSettingsController.js